import { useCallback } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import AsyncReactSelect from "src/components/AsyncReactSelect";
import EntityManagementService from "src/apis/EntityManagementService";

const LegalEntityMultiSelect = ({
    t,
    lng,
    modules,
    organization,
    value,
    onChange,
    placeholder,
    isMulti = true,
    isDisabled = false,
    ...selectProps
}) => {
    const fetchLegalEntitiesOptions = useCallback(async (params) => {
        const entityManagementService = EntityManagementService.getInstance();

        const response = await entityManagementService.fetchEntitesList(
            {
                ...params,
                language_code: lng,
                organization: organization.id
            },
            modules.active
        );

        const options = response.legalEntities.map((entity) => ({
            value: entity.id,
            label: entity.title
        }));

        return {
            options,
            pageIndex: response.pageIndex,
            pageSize: response.pageSize,
            totalCount: response.itemsCount
        };
    }, [
        lng,
        organization.id,
        modules.active
    ]);

    return (
        <AsyncReactSelect
            loadOptions={fetchLegalEntitiesOptions}
            settings={{
                queryKey: "title",
                loadOptionsErrorMessage: "Faild to fetch",
                pageSize: 100
            }}
            value={value}
            onChange={onChange}
            placeholder={placeholder || `${t("Select")}...`}
            isMulti={isMulti}
            isDisabled={isDisabled}
            {...selectProps}
        />
    );
};

const mapStatetoProps = (state) => {
    const { Modules, Organization } = state;

    return {
        modules: Modules,
        organization: Organization
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps
    )(
        LegalEntityMultiSelect
    )
);
